
import { defineComponent, PropType, ref } from "vue";

import {
  ColumnDefinition,
  BaseTable,
  BaseButton,
  DeleteIcon,
  SouthIcon,
  NorthIcon,
  FormField,
} from "@tager/admin-ui";
import { Nullable } from "@tager/admin-services";

import { moveItem } from "@/views/BasisProductForm/BasisProductForm.helpers";

const COLUMN_DEFS: Array<ColumnDefinition> = [
  {
    id: 1,
    name: "Название",
    field: "name",
  },
  {
    id: 2,
    name: "",
    field: "actions",
    style: { width: "140px", textAlign: "center", whiteSpace: "nowrap" },
    headStyle: { width: "140px", textAlign: "center" },
  },
];

type Props = Readonly<{
  options: Array<{ id: Nullable<number>; name: string; canDelete: boolean }>;
}>;

export default defineComponent({
  name: "OptionTable",
  components: {
    BaseTable,
    BaseButton,
    DeleteIcon,
    SouthIcon,
    NorthIcon,
    FormField,
  },
  props: {
    options: {
      type: Array as PropType<Props["options"]>,
      required: true,
    },
  },
  setup(props) {
    function removeField(rowIndex: number) {
      props.options.splice(rowIndex, 1);
    }

    const isOpen = ref<boolean>(false);

    function toggleOptionTable() {
      isOpen.value = !isOpen.value;
    }

    function handleClick(
      itemList: Array<{ id: Nullable<number>; name: string }>,
      itemIndex: number,
      direction: "up" | "down"
    ) {
      moveItem<{ id: Nullable<number>; name: string }>(
        itemList,
        itemIndex,
        direction
      );
    }

    function addElement() {
      props.options.push({
        id: null,
        name: "",
        canDelete: true,
      });
    }

    return {
      columnDefs: COLUMN_DEFS,
      removeField,
      handleClick,
      addElement,
      isOpen,
      toggleOptionTable,
    };
  },
});
